export default "__VITE_ASSET__95d9045b__"